
import TopBarPopover from './top-bar-popover.component';
import { Box } from '@mui/material';
// import Scrollbar from '../scroll-bar/scrollbar';
// import { CallServiceFromServerEvent } from '../../modules/websocket/type';
import { createHashHistory } from 'history';



//  Popover组件
export default function NotificationPopover(props: {
    // Popover 开关
    open: boolean;
    // Popover 锚点
    anchorEl: HTMLElement | null;
    // 关闭Popover
    onClose: () => void;
    // 新通知
    // notifications: CallServiceFromServerEvent[];
    // 新消息条数
    newCount: number;
}) {
    const { open, anchorEl, onClose, newCount } = props;

    // const _renderAvatarItem = (data: CallServiceFromServerEvent) => {
    //     let type = _.get(data, 'type') || 'CALL';
    //     let isTest = _.get(data, 'tableId', '') === 'WS';
    //     if (isTest) {
    //         type = 'TEST_CONNECT'
    //     }
    //     switch (type) {
    //         case 'CALL':
    //             return (
    //                 <SettingsPhone />
    //             )
    //         case 'TEST_CONNECT':
    //             return (
    //                 <Check />
    //             )
    //         case 'QOP_CREATE_ORDER_REQUEST':
    //             return (
    //                 <Restaurant />
    //             )
    //     }
    // }

    return (
        <TopBarPopover
            id='notification'
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            content={
                <Box height={300}>
                    {/* <Scrollbar>
                        <List disablePadding>
                            {notifications && notifications.length > 0 ?
                                notifications.map((item, index) => {
                                    // 内容
                                    let message = '';
                                    // 开台审核
                                    if (_.get(item, 'type') === 'QOP_CREATE_ORDER_REQUEST') {
                                        message = i18n.t('create_order_request')
                                    }
                                    // 测试ws连接
                                    else if (_.get(item, 'tableId') === 'WS') {
                                        message = i18n.t('ws_connection_succeeded')
                                    }
                                    // 呼叫服务
                                    else {
                                        message = (_.get(item, 'checkbox_group', []) || []).toString();
                                        if (_.get(item, 'message', '')) {
                                            message += ' ' + _.get(item, 'message', '');
                                        }
                                    }
                                    // 桌台名称
                                    const tableName = _.get(item, 'table_name', '');
                                    // 日期
                                    const date = moment(item.date).format('YYYY-MM-DD HH:mm:ss')
                                    return (
                                        <ListItem button disableGutters={false} component='a' key={index}>
                                            <ListItemAvatar>
                                                <Avatar className={classes.avatar}>{_renderAvatarItem(item)}</Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={
                                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <Typography variant='subtitle2' color='textPrimary' className='chat-list-item-title-name'>{tableName}</Typography>
                                                        <Typography variant='body2' color='textSecondary'>{date}</Typography>
                                                    </div>
                                                }
                                                secondary={message}
                                                primaryTypographyProps={{ variant: 'subtitle2', className: 'chat-list-item-title' }}
                                                secondaryTypographyProps={{ variant: 'body2', className: `chat-list-item-desc` }}
                                                color='primary' />
                                        </ListItem>
                                    )
                                }) : null
                            }
                        </List>
                    </Scrollbar> */}
                </Box>}
            title={`${newCount} New Notifications`}
            handleClick={() => {
                createHashHistory().push('/main/rbp/callService');
                onClose()
            }}
            newCount={newCount}
        />
    )

}